export default __webpack_public_path__ + "static/media/done.2340fc1e.mp3";